// extracted by mini-css-extract-plugin
module.exports = {"logo":"logo-2CRrP","close":"close-3Wzs7","bottom":"bottom-10ZsT"};